import { Component, Vue } from 'vue-property-decorator';
import AdminManagement from './admin-management/AdminManagement.vue';
import UserManagement from './user-management/UserManagement.vue';
import FeedbackManagement from './feedback-management/FeedbackManagement.vue';
import KMSUsers from './kms-user-management/KMSUserManagement.vue';

enum TabItem {
  ADMIN = 'Admin',
  USER = 'User',
  FEEDBACK = 'Feedback'
}

@Component({
  components: { AdminManagement, UserManagement, FeedbackManagement }
})
export default class Managements extends Vue {
  private tab = 0;
  private readonly tabItems = [
    { title: TabItem.ADMIN, component: AdminManagement },
    { title: TabItem.USER, component: UserManagement },
    { title: TabItem.FEEDBACK, component: FeedbackManagement }
  ];

  mounted(): void {
    this.tab = parseInt(this.$route.params?.tab) ?? 0;
  }
}
